// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";

import TimelineItems from "app/components/TimelineItems/TimelineItems";
import { size } from "app/components/TimelineItem/TimelineItem";
import "./Timeline.scss";

type Props = {
    video: Video,
    items: TimelineItem[],
    selectedItem?: ?TimelineItem,
    onSelect?: Function,
    onDeselect?: Function,
    onMouseEnter?: Function,
    onDrag?: Function,
    onRequestCreate?: Function,
    scale: number,
    isMobile: boolean,
    progress?: number,
    wizard?: boolean,
    editable?: boolean,
    canAdd?: boolean,
    freezeScale?: boolean,
};

@observer
export default class Timeline extends React.Component<Props> {
    render() {
        const scale = this.props.scale;
        const style =
            scale === -1
                ? {}
                : {
                      height: `${size * scale}px`
                  };

        return (
            <div className="Timeline" style={style}>
                <TimelineItems
                    video={this.props.video}
                    items={this.props.items}
                    selectedItem={this.props.selectedItem}
                    onSelect={this.props.onSelect}
                    onDeselect={this.props.onDeselect}
                    onMouseEnter={this.props.onMouseEnter}
                    onDrag={this.props.onDrag}
                    wizard={this.props.wizard}
                    scale={this.props.scale}
                    isMobile={this.props.isMobile}
                    freezeScale={this.props.freezeScale}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Timeline/Timeline.js